export function defineOptionalModule(module) {
    if (!/^[a-z][a-z0-9-]*$/.test(module.id) || !module.displayName.trim()) {
        throw new Error('Optional module identity is invalid.');
    }
    if (!Number.isInteger(module.apiVersion) || module.apiVersion < 1) {
        throw new Error(`Optional module ${module.id} must declare a positive API version.`);
    }
    if (module.dependencies.length !== 0) {
        throw new Error(`Optional module ${module.id} cannot directly depend on another optional module.`);
    }
    for (const capability of module.capabilities) {
        if (!capability.startsWith(`${module.id}.`)) {
            throw new Error(`Optional module ${module.id} capability ${capability} is outside its namespace.`);
        }
    }
    for (const event of module.events) {
        if (!event.startsWith(`${module.id}.`)) {
            throw new Error(`Optional module ${module.id} event ${event} is outside its namespace.`);
        }
    }
    Object.freeze(module.capabilities);
    Object.freeze(module.events);
    Object.freeze(module.dependencies);
    return Object.freeze(module);
}
//# sourceMappingURL=contracts.js.map